<template>
	<sf-data-table
		ref="grpTable"
		:paging="false"
		:columns="cols"
		:rows="rows"
		:stripe="false"
		:selection="false"
		:excel="isButton_(scrId, 'EX')"
		:customExcel="excelFunc"
		:cellClassName="objCellClassName"
		@row-dblclick="searchGraphList"
	>
		<template v-slot:actionsLeft>
			<!-- test code -->
			<!-- pwa 신청-->
			<sf-button line icon="file" :onClick="openReport">
				{{ getMessage_('QWCC001041') }}
			</sf-button>
			<!-- pwa 신청-->
			<sf-button line icon="file" :onClick="downExcelTemp"> 엑셀템플릿 다운 </sf-button>
		</template>
	</sf-data-table>
</template>

<script>
import { rootComputed } from '@/store/common/helpers'; //공통
import { serviceComputed, serviceMethods } from '@qms/GraphInfo/store/helpers';

import utils from '@/utils';
import { BASE_URL } from '@/constants';
import moment from 'moment';
import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.grdSalesList;
		},
		cols() {
			return this.dayCols_;
		}
		/*
		,insVali() {
			return yup.array().of(
				yup.object().shape({
					varId: yup
						.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC000904')])),
					startDt: yup
						.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC000920')]))
				})
			);
		}
		*/
	},
	methods: {
		...serviceMethods,
		...utils, //커스텀 엑셀다운로드시
		excelFunc() {
			//커스텀 엑셀다운로드시 필요한 함수
			let queryStr = '';
			if (this.searchParams.selRowCarCd !== undefined || this.searchParams.selRowCarCd !== undefined) {
				let stMonth = this.searchParams.startMonth;
				let stEnd = this.searchParams.endMonth;

				stMonth = moment(stMonth).startOf('month').format('YYYYMMDD');
				stEnd = moment(stEnd).endOf('month').format('YYYYMMDD');

				queryStr = objectToQuerystring({
					carCd: this.searchParams.selRowCarCd,
					startMonth: stMonth,
					endMonth: stEnd
				});
			}

			//console.log('조회조건>>>>', queryStr);

			//console.log('엑셀컬럼>>>', this.colExcel_);

			const url = `${BASE_URL}/sample/v1/excelGraphInfo` + queryStr;
			const params = { url, columns: this.colExcel_ };
			this.xlsxDown(params).catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			});
		},
		resetTable() {
			this.$emit('Refresh');
		},
		searchGraphList({ carCd }) {
			this.$sf_toggleLoading(true);

			this.setSearchParam_({ key: 'selRowCarCd', value: carCd });

			this.getGraphList_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});

			//this.$emit('Refresh', currentPageVal, pageUnitVal);
		},
		openReport() {
			let params = {
				//jrfName: 'db_oracle.jrf'
				jrfName: 'ship_cn.jrf',
				arg: 'list#nm=ship&node=list#ship#nm=ship&node=ship#BOX_YN#Y'
				//arg: 'list#node=list#ship#node=ship#BOX_YN#Y'
			};

			//console.log('리포트 파람 작성해서 호출함>>>>>>>>>>>>>>>', params);

			this.$emit('rePortPopOpen', params);
		},
		downExcelTemp() {
			let params = {
				origFileName: '20220824_155612.xlsx'
			};

			this.excelTempDown_(params)
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		objCellClassName({ row, column, rowIndex, columnIndex }) {
			//console.log('가나다라마바사>>>', columnIndex);

			if (columnIndex == 6) {
				//console.log('1');
				return 'customCellStyle';
			}
		} /*,
		addAction() {
			//행추가
			this.makeAddDatas();
			this.rows.unshift(...this.addRowDatas);
		},
		changedRow({ rows, changedRow }) {
			let tmpStatus = changedRow.tableState;

			if (tmpStatus !== 'I') {
				changedRow.tableState = 'U';
			}
		},
		saveAction() {
			//저장
			const saveListRows = this.addListSaveRows_; //getters

			if (saveListRows.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('MWCC000103'),
					message: this.getMessage_('QWCC000914')
				}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
				return;
			}

			try {
				//벨리데이션체크
				this.insVali.validateSync(saveListRows);

				//컨펌창
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('MWCC000501'), //저장하시겠습니까?
					buttons: [{ title: this.getMessage_('MWCC000103'), clickFn: () => this.save(saveListRows) }] //저장
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
				return false;
			}
		},
		deleteAction() {
			//delete버튼
			const selected = this.$refs.varTable.getSelectedRows();

			if (selected.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('MWCC000109'),
					message: this.getMessage_('MWCC000110')
				}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
				return;
			}

			let delValiGb = false;
			this.$refs.varTable.multipleSelection.forEach(row => {
				if (row.tableState === 'I') {
					delValiGb = true;
				}
			});

			if (delValiGb === true) {
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC000917') });
				return false;
			}

			try {
				//컨펌창
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('MWCC000108'), //삭제하시겠습니까?
					buttons: [{ title: this.getMessage_('MWCC000107'), clickFn: () => this.remove(selected) }] //삭제
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
				return false;
			}
		},
		resetSelection() {
			//체크박스 해제
			let checkedCount = document.getElementsByClassName('is-checked').length;
			for (let i = 0; i < checkedCount; i++) {
				document.getElementsByClassName('is-checked')[0].classList.remove('is-checked');
			}

			this.$emit('Refresh');
		},
		save(saveRows) {
			let sendData = {
				status: 1,
				data: saveRows
			};

			if (sendData.data != undefined && sendData.data.length > 0) {
				this.$sf_toggleLoading(true);
				this.setVariableManagement_(sendData)
					.then(value => {
						if (value.message != undefined && value.message != null) {
							this.$sf_toast({
								type: value.code === 0 ? 'ok' : 'error',
								message: this.getMessage_(value.messageCd)
							});
						}
						this.resetTable();
					})
					.catch(error => {
						this.$sf_toast({
							type: 'error',
							message: error.message
						});
						Promise.reject(error);
					})
					.finally(() => {
						this.$sf_toggleLoading(false);
					});
			}
		},
		remove(selected) {
			let sendData = {
				status: 3,
				data: selected
			};

			this.$sf_toggleLoading(true);
			this.setVariableManagement_(sendData)
				.then(response => {
					if (response.message != undefined && response.message != null) {
						this.$sf_toast({
							type: response.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(response.messageCd)
						});
					}
					// this.$refs.varTable.deleteHandler(false);
					this.resetSelection();
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		makeAddDatas() {
			this.addRowDatas = [
				{
					rowType: 'add',
					label: '',
					col1: '',
					tableState: 'I',
					useYn: 'Y'
				}
			];
		}
		*/
	}
};
</script>

<style>
.customCellStyle {
	background: brown;
}
</style>
